const Redis = require("ioredis");
let _client;
// On globalThis because Next bundles its own copy of server/, which would otherwise open a second client.
const STATE_KEY = "__homepageElasticacheService";
const shared = globalThis[STATE_KEY] || (globalThis[STATE_KEY] = {});
// Generated per declared resource by helm-charts' generateInfraEnvVars (common-v2/templates/_util.tpl),
// so the name tracks the chart's `elasticache` resource name — `main`.
const getEndpoint = ()=>{
    const overrideHost = process.env.ELASTICACHE_OVERRIDE_HOSTNAME;
    if (overrideHost) {
        return {
            host: overrideHost,
            port: Number(process.env.ELASTICACHE_OVERRIDE_PORT) || 6379,
            isServerless: false
        };
    }
    const host = process.env.ELASTICACHE_ENDPOINT_MAIN_PRIMARY_HOST;
    if (!host) {
        return null;
    }
    return {
        host,
        port: Number(process.env.ELASTICACHE_ENDPOINT_MAIN_PRIMARY_PORT) || 6379,
        isServerless: true
    };
};
const createClient = ({ host, port, isServerless })=>{
    // A local override points at a plain redis with no TLS and no cluster bus.
    if (!isServerless) {
        return new Redis({
            host,
            port
        });
    }
    return new Redis.Cluster([
        {
            host,
            port
        }
    ], {
        // Hands ioredis back the hostname it asked about instead of an IP. Serverless announces both its
        // nodes under the configuration endpoint's own hostname, so keeping the hostname is what lets
        // strict TLS verification pass — resolving to an IP would fail the cert check.
        dnsLookup: (address, callback)=>callback(null, address),
        // Serverless mandates in-transit encryption and uses no password.
        // commandTimeout frees commands stuck on a connected but silent node, which the offline queue never sees.
        redisOptions: {
            tls: {},
            commandTimeout: 1000
        },
        // Reject while the cluster is down instead of queueing without bound; cache-service treats it as a miss.
        enableOfflineQueue: false
    });
};
const init = ()=>{
    const { logInfo, logError } = require("../../logging/logger");
    if (shared.backend) {
        logInfo("Init ElastiCache was called, although it's already initialized.");
        return shared.backend;
    }
    const endpoint = getEndpoint();
    if (!endpoint) {
        throw new Error("No ElastiCache endpoint: ELASTICACHE_ENDPOINT_MAIN_PRIMARY_HOST is unset");
    }
    logInfo(`Initializing ElastiCache on ${endpoint.host}:${endpoint.port}`);
    _client = createClient(endpoint);
    _client.on("connect", ()=>logInfo("Connected to ElastiCache"));
    // Without a listener ioredis raises "error" as an uncaughtException, which reaches server.js's
    // log-only handler as a stackless blob. Handling it here keeps the datastore context.
    // A failed slot refresh reports a generic message; lastNodeError carries the real cause (TLS, DNS, refused).
    _client.on("error", (error)=>{
        var _error_lastNodeError;
        return logError("ElastiCache client error", {
            error: error && error.message,
            cause: error === null || error === void 0 ? void 0 : (_error_lastNodeError = error.lastNodeError) === null || _error_lastNodeError === void 0 ? void 0 : _error_lastNodeError.message
        });
    });
    process.once("SIGINT", ()=>_client.quit());
    shared.backend = {
        getAsync: (...args)=>_client.get(...args),
        setAsync: (...args)=>_client.set(...args),
        delAsync: (...args)=>_client.del(...args)
    };
    return shared.backend;
};
const getBackend = ()=>shared.backend || init();
module.exports = {
    init,
    getAsync: (...args)=>getBackend().getAsync(...args),
    setAsync: (...args)=>getBackend().setAsync(...args),
    delAsync: (...args)=>getBackend().delAsync(...args)
};
